import { render } from "./QuoteDetails.vue?vue&type=template&id=405d195d"
import script from "./QuoteDetails.vue?vue&type=script&lang=js"
export * from "./QuoteDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__